import React, { useEffect, useState, useCallback } from "react";
import { connect } from "react-redux";
import {
  Box,
  Typography,
  Stack,
  // Grid,
  IconButton,
  Button
  // TextField,
  // Autocomplete
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import * as actionType from "../actions";
// import { /*Link,*/ useLocation } from "react-router-dom";
import "./Admin.scss";
import MessageModal from "../../shared/components/MessageModal";
import moment from "moment";
import DataGridPremiumComp from "../../shared/components/DataGridPremiumComp";
import RevenueCalculationModelPopup from "./modals/RevenueCalculationPopup";
import { useNavigate } from "react-router-dom";

const RevenueCalculations = (props) => {
  // const practices = useSelector((state) => state.practices.practices);
  // const pathnames = useLocation().pathname.split("/");
  // if (pathnames[pathnames.length - 1] == "gdm") {
  //   sessionStorage.removeItem("practiceId");
  //   sessionStorage.removeItem("gdmId");
  //   sessionStorage.removeItem("practiceName");
  // }
  const columns = [
    {
      field: "revenueCalculationId",
      headerName: "ID",
      width: 100,
      editable: false,
      flex: 1
    },
    {
      field: "programName",
      headerName: "Program",
      width: 50,
      editable: false,
      flex: 1
    },
    {
      field: "isDonor",
      headerName: "Doner",
      width: 50,
      editable: false,
      flex: 1
    },
    {
      field: "effectiveDate",
      headerName: "EFFECTIVE DATE",
      width: 50,
      editable: false,
      flex: 1,
      renderCell: ({ row }) => {
        return row?.effectiveDate ? moment(row.effectiveDate).format("MM/DD/YYYY") : "";
      }
    },
    {
      field: "endDate",
      headerName: "END DATE",
      width: 50,
      editable: false,
      flex: 1,
      renderCell: ({ row }) => {
        return row?.endDate ? moment(row.endDate).format("MM/DD/YYYY") : "";
      }
    },

    {
      field: "terms",
      headerName: "Terms",
      width: 50,
      editable: false,
      flex: 1
    },
    {
      field: "action",
      headerName: "ACTION",
      width: 50,
      flex: 0.8,
      filterable: false,
      renderCell: ({ row }) => (
        <IconButton
          onClick={() => {
            handleEditRevenueCalculation(row);
            setRevenueCalculationId(row?.revenueCalculationId);
          }}>
          <EditIcon color="primary"></EditIcon>
        </IconButton>
      )
    }
  ];

  const [pageSize, setPageSize] = useState({
    pageSize: 100,
    page: 0
  });

  const {
    revenueCalculationsList = [],
    loading,
    actions,
    success,
    metaData,
    programs,
    error,
    addRevenueCalculation = [],
    editRevenueCalculation = []
  } = props;

  const [rowData, setRowData] = useState({});
  const [revenueCalculationId, setRevenueCalculationId] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isChildOpen, setIsChildOpen] = useState(false);

  const navigate = useNavigate();

  const initFetch = useCallback(() => {
    actions.getRevenueCalculations();
  }, [addRevenueCalculation, editRevenueCalculation]);

  useEffect(() => {
    if (success || error) {
      setIsChildOpen(true);
    }
    if (revenueCalculationsList.length == 0 || addRevenueCalculation || editRevenueCalculation) {
      console.log("initial fetch");
      initFetch();
    }
    return () => {
      actions.resetRevenueCalculation();
    };
  }, [addRevenueCalculation, editRevenueCalculation, success, error]);

  useEffect(() => {
    // if (revenueCalculationsList.length == 0) {
    //   actions.getRevenueCalculations();
    // }
    let payload = { practiceId: "INCLUDE_ALL", gdmId: "INCLUDE_ALL" };
    actions.getPrograms(payload);
    // actions.getMetadata();
  }, []);

  const [rows, setRows] = useState(revenueCalculationsList);

  useEffect(() => {
    setRows(
      revenueCalculationsList?.map((item, index) => {
        item.id = index;
        return item;
      })
    );
  }, [revenueCalculationsList]);

  const handleClose = () => {
    setIsEdit(false);
    setIsOpen(false);
  };

  const closeChildModal = () => {
    actions.resetRevenueCalculationError();
    setIsChildOpen(false);
  };

  const handleEditRevenueCalculation = (row) => {
    const calculationEditData = {
      programName: row?.programName,
      isDonor: row?.isDonor,
      effectiveDate: row?.effectiveDate,
      endDate: row?.endDate,
      terms: row?.terms,
      termMonthPercent: row?.termMonthPercent
      // termMonthPercent: row?.termMonthPercent?.map((item) => {
      //   return Number(item.monthPercent) || 0;
      // })
    };

    setRowData(calculationEditData);
    setIsEdit(true);
    setIsOpen(true);
  };

  const handleLoadExcelData = () => {
    // alert("Load excel data");
    navigate(`loadByExcel`);
  };

  const handleCreateNewCalculation = () => {
    setIsOpen(true);
  };

  const handleSave = (payload) => {
    if (isEdit) {
      actions.editRevenueCalculations({ payload, revenueCalculationId });
    } else {
      actions.addRevenueCalculations(payload);
    }
  };

  return (
    <>
      {/* <Box
        className={`${
          loading || loadingPractice
            ? "stage-details-section m-10 disable-section"
            : "stage-details-section m-10"
        }`}>
        <Stack direction="row" className="modal-stack pad-10">
          <Grid container sx={{ alignItems: "center" }}>
            <Grid item xs={1}>
              <Typography>Program</Typography>
            </Grid>
            <Grid item xs={4}>
              <Autocomplete
                disablePortal
                fullWidth
                name="practiceId"
                value={
                  programs.find((item) => item.programId === programId)
                    ? `${programs.find((item) => item.practiceId === programId).name} - ${programs}`
                    : ""
                }
                options={programs.map((item, index) => {
                  return {
                    id: index,
                    label: `${item.name}`,
                    name: "programId",
                    value: item.programId
                  };
                })}
                onChange={(e, value) => {
                  handleProgramChange(value);
                }}
                renderInput={(params) => <TextField {...params} label="Program..." />}
                className="stage-program-dropdown"
              />
            </Grid>
          </Grid>
        </Stack>
      </Box> */}
      <Box
        sx={{ ml: 1 }}
        className={`${loading ? "m-r-8 m-t-10 disable-section" : "m-r-8 m-t-10"}`}>
        <Stack direction="row" className="grid-header">
          <Typography> Revenue Calculation List</Typography>
          <Stack spacing={2} direction="row">
            <Button variant="contained" onClick={handleLoadExcelData}>
              Load From Excel
            </Button>
            <Button variant="contained" onClick={handleCreateNewCalculation}>
              New Calculation
            </Button>
          </Stack>
        </Stack>
        <Box className="grid-style" sx={{ height: "660px" }}>
          <DataGridPremiumComp
            rows={rows}
            rowCount={rows.length}
            columns={columns}
            loading={loading}
            pageSizeOptions={[10, 25, 50, 100]}
            pageSize={pageSize.pageSize}
            paginationModel={pageSize}
            onPaginationModelChange={(newPageSize) => setPageSize(newPageSize)}
            pagination
          />
        </Box>
      </Box>
      <RevenueCalculationModelPopup
        open={isOpen}
        edit={isEdit}
        data={rowData}
        handleSave={handleSave}
        handleClose={handleClose}
        metaData={metaData}
        programs={programs}
      />

      <MessageModal
        open={isChildOpen}
        error={error}
        message={success}
        closeModal={closeChildModal}
      />
    </>
  );
};

const mapStateToProps = ({
  relativeValueReducer,
  globalDataModelReducer,
  revenueCalculationReducer,
  programReducer
}) => {
  return {
    metaData: relativeValueReducer.metaData,
    gdmList: globalDataModelReducer.globalData,
    addRevenueCalculation: revenueCalculationReducer.addRevenueCalculation,
    editRevenueCalculation: revenueCalculationReducer.editRevenueCalculation,
    revenueCalculationsList: revenueCalculationReducer.revenueCalculationsList,
    loading: revenueCalculationReducer.loading,
    error: revenueCalculationReducer.error,
    success: revenueCalculationReducer.success,
    programs: programReducer.programList
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: {
    getGlobalData: (practiceId) => {
      dispatch(actionType.getGlobalData(practiceId));
    },
    getMetadata: () => {
      dispatch(actionType.getMetadata());
    },
    getRevenueCalculations: () => {
      dispatch(actionType.getRevenueCalculations());
    },
    addRevenueCalculations: (payload) => {
      dispatch(actionType.addRevenueCalculations(payload));
    },
    editRevenueCalculations: (payload) => {
      dispatch(actionType.editRevenueCalculations(payload));
    },
    resetRevenueCalculation: () => {
      dispatch(actionType.resetRevenueCalculation());
    },
    resetRevenueCalculationError: () => {
      dispatch(actionType.resetRevenueCalculationError());
    },
    getPrograms: (payload) => {
      dispatch(actionType.getPrograms(payload));
    }
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(RevenueCalculations);
